import DropPanel from "../1. Core/Controls/DropPanel/DropPanel";
import NumField from "../1. Core/Controls/TextField/NumField";
import NP from "../1. Core/NP";
import Button from "../1. Core/Controls/Button/Button";
import {FunnyItem, HighlightRow, VideoSegmentInfo} from "../10. Battle/types";
import Delegate from "../1. Core/Delegate";
import WorldTimeEdit from "../1. Core/Controls/TimeEdit/WorldTimeEdit";
import {ServerAPI} from "../1. Core/ServerAPI";
import TimeEdit, {TimeEditMode} from "../1. Core/Controls/TimeEdit/TimeEdit";
import CheckBox from "../1. Core/Controls/CheckBox/CheckBox";

let moment = require('moment');


export default class SegmentDP extends DropPanel {
	private _prevSeconds: NumField;
	private _nextSeconds: NumField;
	private _viewFromStart: Button;
	private _viewFromPoint: Button;

	private _Info: VideoSegmentInfo;

	private _wtime: WorldTimeEdit;
	private _Event: HighlightRow | FunnyItem;

	private EvChanged: Delegate;
	private EvFromPointPlay: Delegate;
	private EvFromStartPlay: Delegate;
	private _timeEdit: TimeEdit;
	private _faCB: CheckBox;
	private EvOrderListClick: Delegate;

	private _orderListBtn: Button;
	private _isChanged: boolean;

	_initFields(settings: object)
	{

		this._Event = null;
		this._Info = null;
		this.EvOrderListClick = new Delegate();
		this.EvFromStartPlay = new Delegate();
		this.EvFromPointPlay = new Delegate();
		this.EvChanged = new Delegate();
		super._initFields(settings);
		this._Width = 200;
		this._Height = this.getNeedAddOrderBtn() ? 280 : 250;
	}

	getNeedAddOrderBtn()
	{
		return (this.EvOrderListClick && this.EvOrderListClick.getCount() > 0)
	}

	_render()
	{
		this._Info = this._Event.TimeInfo;

		let initStartValue = this._Info.NextSeconds
		let initPrevValue = this._Info.PrevSeconds

		this.EvOutMouseDown.add(() =>
		{
			if (initStartValue != this._Info.NextSeconds || initPrevValue != this._Info.PrevSeconds || this._isChanged)
			{
				if ((this._Event as HighlightRow).ActionTS)
					ServerAPI.post("/mma/event", this._Event);
				else
					ServerAPI.post('/highlight/updateHighlightFunny', this._Event);

				this._Info.NextSeconds = this._nextSeconds.getValue();
				this._Info.PrevSeconds = this._prevSeconds.getValue();
			}
			this.hide()
		});
		super._render();

		this.addClass('segment-dp')


		this._timeEdit = new TimeEdit({
			Mode: TimeEditMode.Full,
			ParentNode: this._contentDomNode,
			Value: (this._Event as HighlightRow).Time || (this._Event as FunnyItem).HLTime
		})

		this._timeEdit.hide();

		this._wtime = new WorldTimeEdit({
			ParentNode: this._contentDomNode,
			Data: 'ActionTS',
			Value: moment((this._Event as HighlightRow).ActionTS || (this._Event as FunnyItem).HighlightDate, 'YYYY-MM-DD HH:mm:ss.SSS').toDate(),
			EvChanged: () =>
			{
				if ((this._Event as HighlightRow).ActionTS)
					(this._Event as HighlightRow).ActionTS = this._wtime.getValue();
				else
				{
					(this._Event as FunnyItem).HighlightDate = this._wtime.getValue();
					(this._Event as FunnyItem).HighlightTS = this._wtime.getValue();
				}
				this._isChanged  = true
				this.EvChanged.fire(this)
			},
			EvSpinChanged: (s: object, e: { IsPlus: boolean }) =>
			{
				this._timeEdit.incrementValue(e.IsPlus, false)
				if ((this._Event as HighlightRow).Time)
					(this._Event as HighlightRow).Time = this._timeEdit.getValue();
				else
					(this._Event as HighlightRow).HLTime = this._timeEdit.getValue();
			}
		})

		this._prevSeconds = new NumField({
			ParentNode: this._contentDomNode,
			Min: 0,
			Max: 50,
			SpinEdit: true,
			Value: this._Info.PrevSeconds,
			EvChanged: () =>
			{
				this._Info.PrevSeconds = this._prevSeconds.getValue()
				this.EvChanged.fire(this)
			},
			FloatingLabel: NP.RM.getString('PrevSec')
		});

		this._nextSeconds = new NumField({
			ParentNode: this._contentDomNode,
			Min: 0,
			Max: 50,
			SpinEdit: true,
			Value: this._Info.NextSeconds,
			EvChanged: () =>
			{
				this._Info.NextSeconds = this._nextSeconds.getValue()
				this.EvChanged.fire(this)
			},
			FloatingLabel: NP.RM.getString('NextSec')
		});

		this._br(this._contentDomNode)
		this._viewFromStart = new Button({
			ParentNode: this._contentDomNode,
			RK: 'FromStart',
			FontImage: NP.FontImages.arrow_right,
			EvClick: this.EvFromStartPlay
		})
		this._viewFromPoint = new Button({
			ParentNode: this._contentDomNode,
			RK: 'FromPoint',
			FontImage: NP.FontImages.arrow_right,
			EvClick: this.EvFromPointPlay
		})


		if ((this._Event as HighlightRow).EventOrder)
			this._faCB = new CheckBox({
				ParentNode: this._contentDomNode,
				RK: 'Favorite',
				Checked: (this._Event as HighlightRow).Favorite == 1,
				EvCheckedChanged: async () =>
				{
					(this._Event as HighlightRow).Favorite = this._faCB.getChecked() ? 1 : 0;
					await ServerAPI.post('/highlight/updateFavorite', this._Event, false);
					this.EvChanged.fire(this)
				}
			})

		if (this.getNeedAddOrderBtn())
			this._orderListBtn = new Button({
				ParentNode: this._contentDomNode,
				Content: 'Add to order list',
				EvClick: async () =>
				{
					this.EvOrderListClick.fire(this, {Item: this._Event})
					this.hide();
				}
			})
	}
}